import { createSlice } from '@reduxjs/toolkit';
import { INewsDetailState } from '../types';
import { getNewsDetail } from '../../service/api';

const initialState: INewsDetailState = {
  page: null,
  pending: false,
  error: null,
};

export const newsDetailSlice = createSlice({
  name: 'newsDetailSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNewsDetail.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getNewsDetail.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getNewsDetail.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default newsDetailSlice.reducer;
